const CalendarSvg = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 1.5V4.5"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 1.5V4.5"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.25 6.75H15.75"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.25 3H3.75C2.92125 3 2.25 3.67125 2.25 4.5V14.25C2.25 15.0788 2.92125 15.75 3.75 15.75H14.25C15.0788 15.75 15.75 15.0788 15.75 14.25V4.5C15.75 3.67125 15.0788 3 14.25 3Z"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.26097 9.54688C5.15747 9.54688 5.07347 9.63088 5.07422 9.73438C5.07422 9.83787 5.15822 9.92188 5.26172 9.92188C5.36522 9.92188 5.44922 9.83787 5.44922 9.73438C5.44922 9.63088 5.36522 9.54688 5.26097 9.54688"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.01097 9.54688C8.90747 9.54688 8.82347 9.63088 8.82422 9.73438C8.82422 9.83787 8.90822 9.92188 9.01172 9.92188C9.11522 9.92188 9.19922 9.83787 9.19922 9.73438C9.19922 9.63088 9.11522 9.54688 9.01097 9.54688"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.761 9.54688C12.6575 9.54688 12.5735 9.63088 12.5742 9.73438C12.5742 9.83787 12.6582 9.92188 12.7617 9.92188C12.8652 9.92188 12.9492 9.83787 12.9492 9.73438C12.9492 9.63088 12.8652 9.54688 12.761 9.54688"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.26097 12.5469C5.15747 12.5469 5.07347 12.6309 5.07422 12.7344C5.07422 12.8379 5.15822 12.9219 5.26172 12.9219C5.36522 12.9219 5.44922 12.8379 5.44922 12.7344C5.44922 12.6309 5.36522 12.5469 5.26097 12.5469"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.01097 12.5469C8.90747 12.5469 8.82347 12.6309 8.82422 12.7344C8.82422 12.8379 8.90822 12.9219 9.01172 12.9219C9.11522 12.9219 9.19922 12.8379 9.19922 12.7344C9.19922 12.6309 9.11522 12.5469 9.01097 12.5469"
      stroke="#7D8690"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default CalendarSvg;
